import React from "react";
import {useDispatch} from "react-redux";
import moment from "moment";
import {DeleteModal, ExpandableText, TextToolTip} from "components";
import {usePrimaryModal} from "utils";
import {AddNotes} from "./addNotes";
import {Svg} from "assets";
import {Settings} from "../settings";
import {noteActions} from "store";

const DELETE_ACTION_TYPE = "DELETE_GLOBAL_NOTE";

export const NoteCard = ({item, currentId, onResource}) => {
    const dispatch = useDispatch();
    const {openPrimary, closePrimary} = usePrimaryModal();

    const handleEditNote = (e, toggleMenu) => {
        toggleMenu();
        openPrimary(
            <AddNotes item={item} currentId={currentId} onResource={onResource}/>,
            {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 1276
            },
        );
    };

    const deleteNote = (e, toggleMenu) => {
        toggleMenu();
        openPrimary(
            <DeleteModal
                handleDelete={() => {
                    dispatch(
                        noteActions.deleteGlobalNote(item?.id, {
                            id: currentId,
                            onResource,
                        }),
                    );
                }}
                actionType={DELETE_ACTION_TYPE}
                description={"This action is irreversible, and once deleted."}
                title={`Are you sure you want to remove Note ?`}
                handleCancel={closePrimary}
                afterSuccess={closePrimary}
            />,
            {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 407
            },
        );
    };

    const settingsList = () => [
        {
            Svg: Svg.EditInfoSvg,
            text: "Edit",
            handleClick: handleEditNote,
        },

        {
            Svg: Svg.TrashSvg,
            text: "Delete",
            handleClick: deleteNote,
        },
    ];

    return (
        <div className="note-card-wrapper">
            <div className="note-card-box">
                <div className="note-card-main-info-icon_note">
                    <TextToolTip
                        text={
                            <div className="notes-svg-box">
                                <Svg.NoteSvg/>
                            </div>
                        }
                        content="Note"
                        showTooltip
                        wrapperStyles={{width: "fit-content"}}
                    />

                    {item?.text && <ExpandableText htmlContent={item?.text}/>}
                </div>

                <p className="note-card-main-info-dates">
                    <p
                        className="note-card-main-info-text"
                        style={{whiteSpace: "nowrap"}}
                    >
                        {moment.utc(item?.createdDate).format("MM/DD/YYYY")}
                    </p>

                    <p
                        className="note-card-main-info-text"
                        style={{whiteSpace: "nowrap"}}
                    >
                        {moment(item?.createdDate).format("LT")}
                    </p>

                    {item?.user?.firstName && (
                        <p
                            className="note-card-main-info-text"
                            style={{whiteSpace: "nowrap"}}
                        >
                            Created by:
                        </p>
                    )}
                    {item?.user?.firstName && (
                        <TextToolTip
                            classNameText="receivable-note-card-main-info-text"
                            text={`${item?.user?.firstName} ${item?.user?.lastName}`}
                            content={`${item?.user?.firstName} ${item?.user?.lastName}`}
                        />
                    )}
                </p>
            </div>
            <Settings list={settingsList}/>
        </div>
    );
};
